module.exports = __webpack_public_path__ + "media/desk_bell.332b3721.mp3";